import { Box } from "@chakra-ui/react";

import { RanaSelectSearch } from "@nens/ranalib";

import {
  ProcessRunFormFileFeatureSelectorSearchProps,
  useFeatureSelectSearch,
} from "../hooks/use-feature-select-search";

export function ProcessRunFormFileFeatureSelectorSearch(
  props: ProcessRunFormFileFeatureSelectorSearchProps
) {
  const { readonly, disabled } = props.fieldProps;
  const isDisabled = readonly || disabled;
  const {
    isLoading,
    searchString,
    setSearchString,
    filteredPlaceNames,
    selectedPlaceNames,
    onSelectChange,
    maxItemsState,
  } = useFeatureSelectSearch(props);

  const getPlaceHolder = () => {
    if (isLoading) return "Loading...";
    if (selectedPlaceNames.length === 1) return selectedPlaceNames[0];
    if (selectedPlaceNames.length > 1) return `Selected (${selectedPlaceNames.length})`;
    return "Search";
  };

  return (
    <Box>
      <RanaSelectSearch
        w="full"
        showDropdownOnEmptySearch
        isReadOnly={isLoading || isDisabled}
        options={filteredPlaceNames.map((placeName) => ({ value: placeName }))}
        searchState={[searchString, setSearchString]}
        onChange={onSelectChange}
        placeholder={getPlaceHolder()}
        value={selectedPlaceNames.length > 1 ? "" : selectedPlaceNames[0] ?? ""}
        maxItemsState={maxItemsState}
      />
    </Box>
  );
}
